import api from './client'

export async function createSampleHousehold(): Promise<{ id: string }> {
  const { data } = await api.post<{ id: string }>('/households/sample')
  return data
}
